<div [ngClass]="cssClass || 'd-flex align-items-center gap-2'" [formGroup]="form">
  <p-checkbox
    [id]="id"
    [formControlName]="controlName"
    [binary]="true"
    [title]="title || ''">
  </p-checkbox>
  <label [for]="id" class="mb-0">{{ label }}</label>
  <span *ngIf="tooltipText" class="ml-2 cursor-pointer">
    <i class="pi pi-info-circle" [pTooltip]="tooltipText"></i>
  </span>
</div>


